module.exports = __webpack_public_path__ + "img/rugby-ball.9e368154.svg";